module.exports = __webpack_public_path__ + "static/img/16areaA_4.0261ddf.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/16areaA_4.png
// module id = 1017
// module chunks = 1